import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../assets/CSS/post.css';
import '../pages/profile.jsx';
import profilePicPlaceholder from '../assets/Images/ProfilePic-placeholder.jpg';

function Post({ posts, fetchPosts }) {
  const [likeCounts, setLikeCounts] = useState({});
  const [likedPosts, setLikedPosts] = useState({});
  const [comments, setComments] = useState({});
  const [newComments, setNewComments] = useState({});
  const [activeDropdown, setActiveDropdown] = useState(null);

  const storedUser = localStorage.getItem("loggedInUser");
  const userId = storedUser ? JSON.parse(storedUser).id : null;

  useEffect(() => {
    posts.forEach(post => {
      fetchCommentsForPost(post.id);
      fetchLikeCount(post.id);
    });
  }, [posts]);

  const fetchCommentsForPost = async (postId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/comments/post/${postId}`);
      setComments(prev => ({ ...prev, [postId]: response.data }));
    } catch (error) {
      console.error("Feil ved henting av kommentarer:", error);
    }
  };

  const fetchLikeCount = async (postId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/likes/post/${postId}`);
      setLikeCounts(prev => ({ ...prev, [postId]: response.data.length }));
    } catch (err) {
      console.error("Feil ved henting av likes:", err);
    }
  };

  const toggleLike = async (postId) => {
    if (!userId) return;

    const alreadyLiked = likedPosts[postId];
    try {
      if (alreadyLiked) {
        await axios.delete(`${process.env.REACT_APP_API_URL}/likes/post/${postId}/user/${userId}`);
      } else {
        await axios.post("`${process.env.REACT_APP_API_URL}/likes", { postId, userId });
        console.log("User", {userId}, "Liked post", {postId})
      }

      setLikedPosts(prev => ({ ...prev, [postId]: !prev[postId] }));
      fetchLikeCount(postId);
    } catch (err) {
      console.error("Feil ved like-toggle:", err);
    }
  };

  const handleCommentChange = (postId, value) => {
    setNewComments(prev => ({ ...prev, [postId]: value }));
  };

  const handleAddComment = async (postId, event) => {
    if (event.key === "Enter" && newComments[postId]?.trim() !== "") {
      try {
        await axios.post(`${process.env.REACT_APP_API_URL}/comments`, {
          postId,
          userId,
          comment: newComments[postId].trim()
        });
        fetchCommentsForPost(postId);
        setNewComments(prev => ({ ...prev, [postId]: "" }));
        console.log("User", {userId}, "Commented on post", {postId})
      } catch (err) {
        if (err.response && err.response.status === 400) {
          alert("Comment is too long,must be under 200 characters."); 
        } else {
         alert("Something went wrong while uploading the post.");
        }
      }
    }

    
  };

  const handleDelete = async (postId) => {
  try {
    await axios.delete(`${process.env.REACT_APP_API_URL}/posts/${postId}/user/${userId}`);
    console.log("Post", {postId}, "was deleted by user", {userId})
    fetchPosts();
  } catch (err) {
    console.error("Feil ved sletting av post:", err);
  }
};


const toggleDropdown = (postId) => {
  if (activeDropdown === postId) {
    setActiveDropdown(null);
  } else {
    setActiveDropdown(postId);
  }
};



  return (
    <div id="post">
      {posts.map((post) => (
        <div key={post.id} className="post">
          <div className="feed-sidebar">
  <div className="sidebar-left">
    <img
      src={post.profilePicUrl ? `${process.env.REACT_APP_API_URL}${post.profilePicUrl}` : profilePicPlaceholder}
      alt="Profile Pic"
      className="Profilepic"
    />
    <h3>{post.firstName} {post.lastName}</h3>
  </div>
  {post.userId === userId && (
    <div className="dropdown">
      <button className="dropdown-button" onClick={() => toggleDropdown(post.id)}>
        &#8942; 
      </button>
      {activeDropdown === post.id && (
        <div className="dropdown-content">
          <button className="delete-post" onClick={() => handleDelete(post.id)}>Delete</button>
        </div>
      )}
    </div>
  )}
</div>


          <div className="image-card">
            <div className="caption">{post.caption}</div>
              {post.imageUrl && (  //Hvis det finnes et bilde, vis bilde, hvis ikke, ikke vis noe ........... Dette stopper "" empty string fra Ã¥ bli sendt til databasen
                <img
                  src={`${process.env.REACT_APP_API_URL}${post.imageUrl}`}
                  alt="Post"
                  className="post-image"
                />
              )}
          </div>
          <div className="image-separator"></div>
        <div className="like-button-container">
          {post.userId !== userId && (
            <button
              className="like-button"
              onClick={() => toggleLike(post.id)}
            >
              {likedPosts[post.id] ? "Unlike" : "Like"}
            </button>
          )}
          <span className="like-count">{likeCounts[post.id] ?? 0} likes</span>
        </div>

          <div className="comment-section">
            <div className="comments">
              {(comments[post.id] || []).map((comment, index) => (
                <div key={index} className="comment-item">
                  <img
                    src={comment.profilePicUrl ? `${process.env.REACT_APP_API_URL}${comment.profilePicUrl}` : profilePicPlaceholder}
                    alt="Profile-pic"
                    className="Profilepic"
                  />
                  <h4>{comment.firstName} {comment.lastName}
                    <div className="comment-text">{comment.comment}</div>
                  </h4>
                </div>
              ))}
            </div>
            <div className="comment-input">
              <input
                type="text"
                placeholder="Write a comment..."
                value={newComments[post.id] || ""}
                onChange={(e) => handleCommentChange(post.id, e.target.value)}
                onKeyDown={(e) => handleAddComment(post.id, e)}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Post;